import classNames from "classnames";
import { useSiteFeatures } from "../../hooks/useSiteFeatures";
import { PropsWithChildren } from "react";
import { cockpitComponent } from "../CockpitLayoutComponents";
import "./style.scss";

const GridLayout = ({
  withGaps = false,
  maxColCount = 0,
  id,
  className,
  requiresFeature,
  children,
  ...unhandledProps
}: PropsWithChildren<{
  withGaps?: boolean;
  maxColCount?: number;
  id?: string;
  className?: string | string[];
  requiresFeature?: string;
}>) => {
  const DEMO = false;
  const features = useSiteFeatures();
  return !requiresFeature || features.hasFeature(requiresFeature) ? (
    <div
      id={id}
      className={classNames("grid-layout", className, {
        "with-gaps": withGaps,
        ["max-col-count-" + maxColCount]: maxColCount > 0
      })}
      {...unhandledProps}
    >
      {children}
      {DEMO &&
        [
          "white",
          "grey",
          "sand",
          "black",
          "smoke",
          "green",
          "highlight",
          "hw-white",
          "hw-beige",
          "hw-brown",
          "hw-red",
          "hw-olive",
          "hw-green",
          "ew-white",
          "ew-beige",
          "ew-green",
          "ew-brown",
          "ew-red",
          "ew-dark",
          "rc-white",
          "rc-beige",
          "rc-grey",
          "rc-blue",
          "rc-green",
          "rc-yellow",
          "rc-red"
        ]
          .map((theme, i) => ({
            component: "content_section",
            settings: {
              id: "",
              class: "grid-cell-size-" + ["1x1", "1x2", "2x1", "2x2"][i % 4],
              style: "",
              theme,
              requires_feature: "",
              disabled: false
            },
            children: [
              {
                component: "bjelin_heading",
                settings: {
                  id: "",
                  class: "",
                  style: "",
                  tag: "h2",
                  alignment: "center",
                  text: theme,
                  disabled: false
                }
              }
            ]
          }))
          .map((data, i) => cockpitComponent(data, i))}
    </div>
  ) : null;
};

export default GridLayout;
